import type { ComponentProps } from "react";

type SvgProps = ComponentProps<"svg">;

const TopicTravel = ({ ...rest }: SvgProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M17.8734 8.75L13.2059 8.75C12.9991 8.75 12.8068 8.6434 12.6971 8.468L8.04968 1.032C7.93998 0.85657 7.74768 0.749999 7.54088 0.749999L6.64188 0.749999C6.25148 0.749999 5.96508 1.11683 6.05978 1.49552L7.68698 8.00448C7.78168 8.3832 7.49528 8.75 7.10488 8.75L4.14568 8.75C3.97258 8.75 3.80798 8.6753 3.69408 8.5451L1.80388 6.38481C1.40278 5.9265 0.652982 6.28808 0.761982 6.88724L1.35388 10.1427C1.36678 10.2136 1.36678 10.2864 1.35388 10.3573L0.761981 13.6128C0.652981 14.2119 1.40278 14.5735 1.80388 14.1152L3.69408 11.9549C3.80798 11.8247 3.97258 11.75 4.14568 11.75L7.10488 11.75C7.49528 11.75 7.78168 12.1168 7.68698 12.4955L6.05978 19.0045C5.96508 19.3832 6.25148 19.75 6.64188 19.75L7.54088 19.75C7.74768 19.75 7.93998 19.6434 8.04968 19.468L12.6971 12.032C12.8068 11.8566 12.9991 11.75 13.2059 11.75L17.8734 11.75C18.7018 11.75 19.3734 11.0784 19.3734 10.25C19.3734 9.4216 18.7018 8.75 17.8734 8.75Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default TopicTravel;
